/* eslint-disable import/no-unresolved */
import React, { Component } from "react";
import { selectors, actions } from "reducers/checks";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import { shape, func, bool, string } from "prop-types";
import ContextMenu from "pages/_components/ContextMenu";
import { emittedEcheqsStatusActions, echeqShape } from "util/checks";
import specialOptions, { receivedEcheqAction } from "pages/checks/Echeqs/EcheqActions/EcheqsActionMaker";
import Button from "pages/_components/Button";
import { Box } from "@ui-kit/components/index.es";

const FORM_ID = "echeq";

const echeqsIcons = {
    negociate: "BankSend",
    "emit.cesion": "Endosar",
    deposit: "Deposit",
    "request.return": "ClipboardBack",
    "anulate-echeq": "Error",
};

class EmittedContextMenu extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        echeq: shape(echeqShape).isRequired,
        isDesktop: bool.isRequired,
        environmentCuit: string.isRequired,
        detailActions: bool,
        serverSearchDate: string.isRequired,
        isSmallDesktop: bool,
        setState: func.isRequired,
        location: shape({
            pathname: string.isRequired,
        }).isRequired,
    };

    static defaultProps = {
        detailActions: false,
        isSmallDesktop: false,
    };

    echeqActions = (status) => {
        const actionsEcheqs = emittedEcheqsStatusActions;
        const { dispatch, echeq, environmentCuit, isDesktop, serverSearchDate, setState, location } = this.props;

        let contextMenuActions = [];

        if (!isDesktop) {
            contextMenuActions = [
                {
                    label: "echeq.request.moreInfo.download",
                    onClick: () => {
                        dispatch(actions.downloadEcheqMobileInfo("pdf", echeq));
                    },
                    icon: "Eye",
                },
            ];
        }

        contextMenuActions = [
            ...contextMenuActions,
            ...specialOptions(echeq, serverSearchDate, environmentCuit, (action, echeqInfo) =>
                receivedEcheqAction(
                    action,
                    echeqInfo,
                    dispatch,
                    (newState) => setState({ ...newState }),
                    isDesktop,
                    [],
                    false,
                    location.pathname,
                ),
            ),
        ];
        if (actionsEcheqs[status]) {
            actionsEcheqs[status].forEach((action) => {
                contextMenuActions = [
                    ...contextMenuActions,
                    {
                        label: `${FORM_ID}.${action.toLowerCase()}.echeq`,
                        onClick: () => {
                            receivedEcheqAction(
                                action,
                                echeq,
                                dispatch,
                                (newState) => setState({ ...newState }),
                                isDesktop,
                                [],
                                false,
                                location.pathname,
                            );
                        },
                        icon: echeqsIcons[action.toLowerCase()],
                    },
                ];
            });
        }
        return contextMenuActions;
    };

    render() {
        const { echeq, isDesktop, detailActions, isSmallDesktop } = this.props;
        const { innerWidth: width } = window;

        if (!echeq) {
            return null;
        }

        const itemsContextMenu = this.echeqActions(echeq.estado);
        const maxButtonsActions = width > 859 && width < 1137 ? 2 : 3;
        let filteredEcheqActions;
        let depositOrCustodyButton;
        if (itemsContextMenu.length > 0) {
            depositOrCustodyButton = itemsContextMenu.find(
                (item) => item.label === "echeq.deposit.echeq" || item.label === "echeq.custody.echeq",
            );
            filteredEcheqActions = itemsContextMenu.filter((item) => item.label !== depositOrCustodyButton?.label);
        }

        return (
            <Box flex gap={16}>
                {detailActions &&
                    isDesktop &&
                    !isSmallDesktop &&
                    itemsContextMenu.length <= maxButtonsActions &&
                    itemsContextMenu?.map((item) => (
                        <Button
                            className="btn-outline cmf-button-width"
                            block
                            label={item.label}
                            onClick={item.onClick}
                        />
                    ))}
                {detailActions && isDesktop && (itemsContextMenu.length > maxButtonsActions || isSmallDesktop) && (
                    <>
                        {depositOrCustodyButton && (
                            <Button
                                className="btn-outline cmf-button-width"
                                block
                                label={depositOrCustodyButton.label}
                                onClick={depositOrCustodyButton.onClick}
                            />
                        )}
                        {filteredEcheqActions?.map((echeqAction) => (
                            <Button
                                className="btn-outline cmf-button-width"
                                block
                                label={echeqAction.label}
                                onClick={echeqAction.onClick}
                            />
                        ))}
                    </>
                )}
                {(!detailActions || !isDesktop) && itemsContextMenu.length > 0 && (
                    <ContextMenu
                        styleContext={{ justifyContent: "flex-end", marginRight: 0 }}
                        isDesktop={isDesktop}
                        items={itemsContextMenu}
                        color={!isDesktop && detailActions ? "white" : undefined}
                    />
                )}
            </Box>
        );
    }
}

const mapStateToProps = (state) => ({
    echeqsList: selectors.getEcheqsList(state),
    environmentCuit: selectors.getEnvironmentCuit(state),
    serverSearchDate: selectors.getServerSearchDate(state),
});

export default compose(withRouter, connect(mapStateToProps))(EmittedContextMenu);
